import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, DollarSign } from "lucide-react";

/**
 * Snooze status banners — admin-side amber card with "Run invoice now"
 * action; policyholder-side emerald "enjoy the win" banner. Returns null
 * unless the claim has a snooze active.
 */
export function SnoozeCards({ claim, user, onRunSnoozedInvoice }) {
  if (!claim?.auto_invoice_snoozed_until) return null;

  if (user?.role === "admin") {
    const settlement = Number(claim.auto_invoice_snoozed_settlement || 0);
    const fee = (
      settlement * Number(claim.auto_invoice_snoozed_fee_pct || 0) / 100
    ).toFixed(2);
    return (
      <Card
        className="border-[#C25934]/40 bg-[#FEF3EC] mb-8"
        data-testid="auto-invoice-snooze-card"
      >
        <CardContent className="p-5 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <DollarSign className="w-5 h-5 text-[#C25934] mt-0.5" />
            <div>
              <p className="font-['Outfit'] font-semibold text-[#1E3F33]">
                Auto-invoice snoozed for 24 hours
              </p>
              <p className="text-sm text-gray-700 mt-0.5">
                ${settlement.toLocaleString()} settlement · ${fee} fee due ·
                releases{" "}
                {new Date(claim.auto_invoice_snoozed_until).toLocaleString()}
              </p>
            </div>
          </div>
          <Button
            size="sm"
            className="btn-primary rounded-full"
            onClick={onRunSnoozedInvoice}
            data-testid="run-snoozed-invoice-button"
          >
            Send fee invoice now
          </Button>
        </CardContent>
      </Card>
    );
  }

  if (user?.role === "policyholder") {
    return (
      <Card
        className="border-emerald-200 bg-emerald-50 mb-8"
        data-testid="snooze-policyholder-banner"
      >
        <CardContent className="p-5 flex items-start gap-3">
          <CheckCircle2 className="w-5 h-5 text-emerald-700 mt-0.5" />
          <div>
            <p className="font-['Outfit'] font-semibold text-emerald-900">
              Approved — enjoy the win.
            </p>
            <p className="text-sm text-emerald-800 mt-0.5">
              Your ClaimScope fee invoice will arrive within 24 hours.
              No action needed today.
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return null;
}
